import React, { useMemo } from 'react';
import Select from '../../atoms/Select';
import useLocalizationContext from '../../shared/LocalizationContext/useLocalizationContext';
import { LanguageSelectProps } from './LanguageSelect.types';

export const LanguageSelect = (props: LanguageSelectProps) => {
  const { language, supportedLanguages, setLanguage } = useLocalizationContext();

  const options: LanguageSelectProps['options'] = useMemo(() => {
    return supportedLanguages.map((sl) => ({
      const: sl.language,
      title: sl.name,
    }));
  }, [supportedLanguages]);

  const handleSelectValue: LanguageSelectProps['onSelectValue'] = (value) => {
    setLanguage(value);
  };

  return (
    <Select
      {...{
        graphical: true,
        variant: 'text',
        selectedValue: language,
        options,
        onSelectValue: handleSelectValue,
        ...props,
      }}
    />
  );
};

export default LanguageSelect;
